import { Product } from '@spike/product-model';

export const getTrackedOnHand = (product?: Product): number | undefined => {
    const businessProduct = product?.businessProduct;
    const tracksStock = businessProduct?.inventory?.inventoryTracking !== false;
    const onHand = Number(businessProduct?.onHand);

    if (!product || !tracksStock || !Number.isFinite(onHand)) {
        return undefined;
    }

    return onHand;
};

export const insufficientStockMessage = (onHand: number): string =>
    `Quantity cannot exceed available batch stock (${onHand} available)`;
